import React, { useMemo, useState } from "react";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { ReactComponent as EditIcon } from "../../../assets/svgs/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgs/deleteIcon.svg";
import { SearchBar } from "../../../components/Elements/Search/SearchBar";
import { ReactComponent as FilterIcon } from "../../../assets/svgs/filter-icon.svg";
import EditLocation from "../CustomerDetailPage/Roles/DIalogBoxes/EditLocation";
import AddLocation from "../CustomerDetailPage/Roles/DIalogBoxes/AddLocation";
import FilterLocationDeparment from "../CustomerDetailPage/Roles/DIalogBoxes/FilterLocationDepartment";
import { Button } from "antd";
import { fetchAddedLocation, deleteLocation } from "../../../redux/customer/customerSlice";
import CardsBorder from "../../../components/Cards/CardsBorder";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { ReactComponent as AddDepartmentIcon } from "../../../assets/svgs/add-department.svg"
import { useSelector, useDispatch } from "react-redux";
import { setSelectedLocation } from "../../../redux/customer/customerSlice";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AssignDepartment from "./Roles/DIalogBoxes/AssignDepartment";
const Location = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [addLocations, setAddLocations] = useState(false);
  const [editLocations, setEditLocations] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [selectedLocationForDept, setSelectedLocationForDept] = useState(null);
  const [addDepartment, setAddDepartment] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    visible: false,
    locationId: null,
    locationName: "",
  });
 const { userId } = useParams();
  const [successPopup, setSuccessPopup] = useState({
    visible: false,
    title: "",
    message: "",
  });
  const pageSize = 5;
    const dispatch = useDispatch();
   //----API CALL---
  useEffect(() => {
    if (userId) {
      dispatch(fetchAddedLocation(userId));
    }
  }, [dispatch, userId]);

  //---REDUX STATE---
  const { customerAddedLocation, currentCustomer } = useSelector((state) => state.customer);
  const orgSetup = currentCustomer?.orgStructureMode || "";

  // Frontend filtering logic
  const filteredLocationData = useMemo(() => {
    return (customerAddedLocation || []).filter((location) => {
      // Status Filter
      if (statusFilter) {
        const isActive = statusFilter === "active";
        if (location.isActive !== isActive) return false;
      }

      // Search Filter
      if (searchTerm) {
        const search = searchTerm.toLowerCase();
        const statusText = location.isActive ? "active" : "inactive";
        const matches = 
          (location.name || "").toLowerCase().includes(search) ||
          (location.location_type || "").toLowerCase().includes(search) ||
          (location.city || "").toLowerCase().includes(search) ||
          statusText.includes(search);
        
        if (!matches) return false;
      }

      return true;
    });
  }, [customerAddedLocation, searchTerm, statusFilter]);

  // Get Table Data
  const tableData = useMemo(() => {
    return filteredLocationData.map((location, index) => {
      const row = {
        key: location._id || index,
        serial: <div className="text-center">{index + 1}</div>,
        locationName: <div className="text-center">{location.name}</div>,
        locationType: <div className="text-center">{location.location_type || "--"}</div>,
        locationCity: <div className="text-center">{location.city || "--"}</div>,
        status: <div className="text-center">  {location.isActive ? "Active" : "Inactive"}</div>,
        action: (
          <div className="flex gap-4 justify-center" title="">
            {orgSetup === "location-first" && (
              <AddDepartmentIcon
                onClick={() => {
                  setSelectedLocationForDept(location._id);
                  setAddDepartment(true);
                }}
              />
            )}
            <EditIcon onClick={() => {
              dispatch(setSelectedLocation(location._id));
              setEditLocations(true);
            }} />
            <DeleteIcon
              onClick={() =>
                setDeleteConfirmation({
                  visible: true,
                  locationId: location._id,
                  locationName: location.name,
                })
              }
            />
          </div>
        ),
      };

      if (orgSetup === "location-first") {
        row.departments = (
          <div className="text-center">{location.departmentsCount || 0} Departments</div>
        );
      }

      return row;
    });
  }, [filteredLocationData, orgSetup, dispatch]);

  // Table Headers
  const headers = useMemo(() => {
    const baseHeaders = [
      { label: "Sr. No.", key: "serial" },
      { label: "Location Name", key: "locationName" },
      { label: "Type", key: "locationType" },
      { label: "City", key: "locationCity" },
    ];

    if (orgSetup === "location-first") {
      baseHeaders.push({ label: "Departments", key: "departments" });
    }

    baseHeaders.push(
      { label: "Status", key: "status" },
      { label: "Action", key: "action" }
    );

    return baseHeaders;
  }, [orgSetup]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <CardsBorder>
        <div className="p-1">
          <div className="flex flex-wrap justify-between gap-3 my-3 font-medium">
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-[#06513D] px-3 text-xl whitespace-nowrap">Locations</p>

              <SearchBar width="200px" onSearch={(val) => {
                setSearchTerm(val);
                setCurrentPage(1);
              }} />

              <Button
                style={{ background: "#E6EDEB", border: "solid 1px #06513D" }}
                className="text-[12px] text-[#06513D] hover:text-[#06513D] font-light px-4 py-5"
                onClick={() => setOpenFilter(true)}
              >
                <FilterIcon className="mr-1" />
                FILTER
              </Button>
            </div>

            {/* Right Section */}
            <div className="flex flex-wrap gap-2 px-4">
              <Button
                style={{ background: "#E6EDEB", border: "1px solid #06513D" }}
                className="text-sm h-[50px] text-[#06513D] hover:"
                onClick={() => navigate(`/customer/customer-page/${userId}/import-location`)}
              >
                Import Location
              </Button>

              <CustomButton
                buttonType="primary"
                variant="ok"
                buttonText="+ ADD LOCATION"
                className="text-sm h-[50px]"
                 onClick={() => setAddLocations(true)}
              />
            </div>
          </div>
          <div className="overflow-x-auto w-full">
            <Tables
              data={tableData}
              headers={headers}
              onChange={handlePageChange}
              pageSize={pageSize}
              current={currentPage}
              total={tableData.length}
            />
          </div>
        </div>
      </CardsBorder>
      {/* Delete Confirmation */}
      {deleteConfirmation.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="warning"
            title="Confirm Delete"
            message={`Are you sure you want to delete ${deleteConfirmation.locationName}?`}
            showActions={true}
            confirmText="Yes, Delete"
            cancelText="Cancel"
            onCancel={() =>
              setDeleteConfirmation({
                visible: false,
                locationId: null,
                locationName: "",
              })
            }
            onConfirm={() => {
               dispatch(deleteLocation({ locationId: deleteConfirmation.locationId}))
                .unwrap()
              setDeleteConfirmation({
                visible: false,
                locationId: null,
                locationName: "",
              });

              setSuccessPopup({
                visible: true,
                title: "Deleted",
                message: "Location deleted successfully!",
              });

              setTimeout(() => {
                setSuccessPopup({
                  visible: false,
                  title: "",
                  message: "",
                });
              }, 3000);
            }}
          />
        </div>
      )}

      {/* Success Popup */}
      {successPopup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="success"
            title={successPopup.title}
            message={successPopup.message}
          />
        </div>
      )}
      {/* ----Add new location---- */}
      {addLocations && (
        <AddLocation
          onOpen={addLocations}
          onClose={() => setAddLocations(false)}
        />
      )}
      {/* ----Edit Location------ */}
      {editLocations && (
        <EditLocation
          onOpen={editLocations}
          onClose={() => setEditLocations(false)}
          userId={userId}
        />
      )}
      {/* --------Open Filter-------- */}
      {openFilter && (
        <FilterLocationDeparment
          onOpen={openFilter}
          onClose={() => setOpenFilter(false)}
          initialStatus={statusFilter}
          onApply={({ status }) => {
            setStatusFilter(status);
            setCurrentPage(1);
          }}
        />
      )}
  {/* --------Open addDepartment-------- */}
      {addDepartment && (
        <AssignDepartment
          onOpen={addDepartment}
          locationId={selectedLocationForDept}
          onClose={() => {
            setAddDepartment(false);
            setSelectedLocationForDept(null);
          }}
        />
      )}
    </div>
  );
};

export default Location;
